export default __webpack_public_path__ + "static/media/info.c7b1ce58.svg";